import React, { ReactNode, RefObject, useEffect, useRef } from "react"

interface OutsideClickProps {
  callback: () => void
  boxSize?: number
  className?: string
  yPos?: number
  right?: string
  children: ReactNode
}

const useOutsideClick = (ref: RefObject<HTMLDivElement>, callback: () => void) => {
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      const { target } = event
      if (ref.current && !ref.current.contains(target)) {
        callback()
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [callback, ref])
}

function OutsideClick({ callback, boxSize = 0, className, yPos = 0, right, children }: OutsideClickProps) {
  const wrapperRef = useRef<HTMLDivElement>(null)
  useOutsideClick(wrapperRef, callback)

  return (
    <div
      className={className}
      ref={wrapperRef}
      style={{
        top: yPos + +boxSize > window.innerHeight ? "" : yPos,
        right,
        bottom: yPos + +boxSize > window.innerHeight ? 10 : "",
        height: "24px",
      }}
    >
      {children}
    </div>
  )
}

export default OutsideClick
